<script setup lang="ts">

  import type { FieldConfig } from '@/types'
  import { formatInlineDescription } from '@/utils/formatDescription'

  defineProps<{
    field: FieldConfig,
  }>()

  const emit = defineEmits<{
    (e: 'open-modal', description: FieldConfig['description']): void,
  }>()

</script>

<template>
  <!-- Title -->
  <div
    v-if="field.label || field.sublabel"
    class="flex items-center gap-2 mb-2">
    <h3 class="font-semibold text-secondary-3 text-sm sm:text-base">
      {{ field.label }}
      <span
        v-if="field.sublabel"
        class="text-xs text-secondary-2">{{ field.sublabel }}</span>
    </h3>
    <button
      v-if="field.description && field.isDetail"
      type="button"
      class="text-secondary-2 hover:text-secondary-3"
      @click="emit('open-modal', field.description)">
      <svg
        class="size-4 sm:size-5"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor">
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
    </button>
  </div>

  <!-- Description -->
  <div
    v-if="field.description && !field.isDetail"
    class="mb-3 sm:mb-4">
    <p class="text-xs text-secondary-2">
      {{ typeof field.description === 'string' ? field.description.split('\n').find(item => !item.trim().startsWith('- ')) : 'Details' }}
    </p>
    <ul class="list-disc pl-5 text-xs sm:text-sm text-gray-500 space-y-1">
      <li
        v-for="(item, index) in formatInlineDescription(field.description)"
        :key="index">
        {{ item }}
        <p
          v-if="Array.isArray(field.description) && typeof field.description[index] === 'object' && field.description[index].subtext"
          class="text-xs text-gray-400 mt-1">
          {{ field.description[index].subtext }}
        </p>
      </li>
    </ul>
  </div>
</template>
